export default __webpack_public_path__ + "static/media/1.26c7a963.png";